module.exports = __webpack_public_path__ + "media/images/manage_courses_active-23ca9ce06891ad1ed362ad6ae6c76b53.png";